import { __assign, __rest } from "tslib";
import React from 'react';
import { Svg } from '@marvelapp/ui';
export default function LayerOval(_a) {
    var props = __rest(_a, []);
    return (React.createElement(Svg, __assign({ display: "block", height: "24px", viewBox: "0 0 24 24", width: "24px" }, props),
        React.createElement("path", { d: "M12,17.5A5.5,5.5,0,1,1,17.5,12,5.51,5.51,0,0,1,12,17.5Z", fillRule: "evenodd", opacity: "0.22" }),
        React.createElement("path", { d: "M12,7a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-1a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z" })));
}
